export default class InvalidUserOrPasswordError extends Error {}
